import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import GardenFence from "@/pages/GardenFence";

export const Route = createFileRoute("/_public/services/garden-fence")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Garden Fence Installation | Modern Fence Install", "Professional garden fence installation \u2014 low-profile mesh fencing that protects vegetable beds and borders from rabbits, groundhogs and deer.", "/services/garden-fence", false),
  component: GardenFence,
});
